import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPersonSuppliersList } from '@store/NTX/Peoples/peoplesSlice';
import { useTranslation } from 'react-i18next';

const useGetPersonSuppliersList = () => {
  const { i18n } = useTranslation();

  const dispatch = useAppDispatch();
  const { PersonSuppliersList, loading2: loading, error2: error } = useAppSelector(state => state.Peoples);
  useEffect(() => {
    if (PersonSuppliersList?.length === 0) {
      dispatch(getPersonSuppliersList('EMPLOYEE'));
    }
  }, [PersonSuppliersList?.length, dispatch]);

  const OptionPersonSuppliers = PersonSuppliersList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2,
    id: item.id,
    // parentId: item.parentId,
    // termsId: item.termsId,
    paymentMethodId: item.paymentMethodId,
    paymentCurrencyCode: item.paymentCurrencyCode,
    // billToLocationId: item.billToLocationId,
    // shipToLocationId: item.shipToLocationId,
    invoiceCurrencyCode: item.invoiceCurrencyCode,
    personId: item.personId,
  }));

  return {
    PersonSuppliersList,
    OptionPersonSuppliers,
    loading,
    error
  };
};

export default useGetPersonSuppliersList;
